// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"6701170bfd65800d4357","263":"ec7b8188f7afc3d64805","791":"8f59985adc42c27dc2e1"}[chunkId] + ".js";
};